function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Categories");

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 20.92,
  y: 23.44,
  width: 35.04,
  height: 35.04
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 91.01,
  y: 23.44,
  width: 35.04,
  height: 35.04
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 161.1,
  y: 23.44,
  width: 35.04,
  height: 35.04
});

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  x: 20.92,
  y: 93.53,
  width: 35.04,
  height: 35.04
});

var _ref6 =
/*#__PURE__*/
React.createElement("rect", {
  x: 91.01,
  y: 93.53,
  width: 35.04,
  height: 35.04
});

var _ref7 =
/*#__PURE__*/
React.createElement("rect", {
  x: 161.1,
  y: 93.53,
  width: 35.04,
  height: 35.04
});

var _ref8 =
/*#__PURE__*/
React.createElement("rect", {
  x: 20.92,
  y: 163.62,
  width: 35.04,
  height: 35.04
});

var _ref9 =
/*#__PURE__*/
React.createElement("rect", {
  x: 91.01,
  y: 163.62,
  width: 35.04,
  height: 35.04
});

var _ref10 =
/*#__PURE__*/
React.createElement("rect", {
  x: 161.1,
  y: 163.62,
  width: 35.04,
  height: 35.04
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 218.79 216.42"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

export default __webpack_public_path__ + "static/media/RoundCategory.8b58c62a.svg";
export { SvgComponent as ReactComponent };